import React from "react"
import { Link } from "gatsby"
import { NavigationLinksOutput } from "contexts/settings/Navigation/navigation-types"
import { useLayout } from "contexts/components/LayoutContext"
import "./main-navigation.module.scss"
import { getRelativePathFromCodex } from "components/button/utils/getRelativePathFromCodex"

interface MainNavigationProps {
  navItem: NavigationLinksOutput
  index: number
  navCount: number
}

export const MainNavigation = ({ navItem }: MainNavigationProps) => {
  const { linkedPagesUrlPathCodex } = useLayout()
  const { slug, linkText, migratedUrl, externalLink } = navItem

  const pageSlug = slug || migratedUrl

  const path = getRelativePathFromCodex({
    codex: linkedPagesUrlPathCodex,
    path: pageSlug,
    codexKeyStartsWithForwardSlash: false,
  })

  return (
    <>
      {externalLink ? (
        <a className="fr-header__link" href={externalLink} target="_blank">
          {linkText}
        </a>
      ) : (
        <Link
          to={path}
          className="fr-header__link"
          activeClassName="fr-header__link--current"
        >
          {linkText}
        </Link>
      )}
    </>
  )
}
